import friabilometro1 from '../friabilometro/friabilometro1.png'

const imagefriabilometro = [
    friabilometro1,
]

export default imagefriabilometro